module.exports = __webpack_public_path__ + "static/media/Close.a4f3566a.png";